import { Plus, X } from "lucide-react";
import { money } from "@/lib/helpers";

export default function CostItemsEditor({ items = [], units = 1, onChange, onUnitsChange }) {
  const total = items.reduce((s, i) => s + (Number(i.amount) || 0), 0);
  const u = Number(units) || 1;
  const perUnit = total / (u > 0 ? u : 1);
  const update = (idx, field, val) => onChange(items.map((it, i) => (i === idx ? { ...it, [field]: val } : it)));
  const add = () => onChange([...items, { label: "", amount: "" }]);
  const remove = (idx) => onChange(items.filter((_, i) => i !== idx));

  return (
    <div className="space-y-2" data-testid="cost-items-editor">
      <label className="block text-xs font-medium uppercase tracking-wider text-zinc-500">Cost breakdown</label>
      {items.length === 0 && <p className="text-xs text-zinc-400">No line items yet — add shipping, customs, purchase, etc.</p>}
      {items.map((it, i) => (
        <div key={i} className="flex items-center gap-2" data-testid={`cost-item-${i}`}>
          <input value={it.label} onChange={(e) => update(i, "label", e.target.value)} placeholder="e.g. Shipping" data-testid={`cost-item-label-${i}`} className="flex-1 border border-zinc-200 px-2 py-1.5 text-sm outline-none focus:border-[#e84e34]" />
          <input type="number" step="0.01" value={it.amount} onChange={(e) => update(i, "amount", e.target.value)} placeholder="0.00" data-testid={`cost-item-amount-${i}`} className="w-28 border border-zinc-200 px-2 py-1.5 text-sm outline-none focus:border-[#e84e34]" />
          <button type="button" onClick={() => remove(i)} data-testid={`cost-item-remove-${i}`} className="text-zinc-300 hover:text-[#e84e34]"><X className="h-4 w-4" /></button>
        </div>
      ))}
      <button type="button" onClick={add} data-testid="cost-item-add" className="flex items-center gap-1 text-xs font-medium text-[#e84e34] hover:underline"><Plus className="h-3 w-3" /> Add line item</button>

      <div className="flex items-center gap-2 pt-1">
        <label className="text-xs font-medium uppercase tracking-wider text-zinc-500">Units</label>
        <input type="number" min="1" step="1" value={units} onChange={(e) => onUnitsChange(e.target.value)} data-testid="equipment-units-input" className="w-24 border border-zinc-200 px-2 py-1.5 text-sm outline-none focus:border-[#e84e34]" />
      </div>

      <div className="mt-1 border-t border-zinc-200 pt-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-zinc-500">Total cost</span>
          <span className="font-heading font-bold text-zinc-900" data-testid="cost-total">{money(total)}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-zinc-500">Per unit ({u})</span>
          <span className="font-heading font-bold text-[#e84e34]" data-testid="cost-per-unit">{money(perUnit)}</span>
        </div>
      </div>
    </div>
  );
}
